import React, { useMemo } from 'react';
import styled from 'styled-components';
import SbEditable from 'components/SbEditableExtended';

import ReactPlayer from 'react-player/lazy';

import WhiteBox from 'components/blocks/blockPartials/whiteBox';

import theme from 'settings/theme';

import calculateBottomSpacingClass from 'components/blocks/utils/calculateBottomSpacingClass';
import multiOptionsToObject from 'components/blocks/utils/multiOptionsToObject';



// Make Youtube Thumb URL
const makeYoutubeThumbUrl = (youtubeId) => {
  return `https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg`
};


const getProvider = (url) => {

  try{
    url = new URL(url);
  }
  catch(e){
    return 'unknown';
  }

  const players = ['youtube', 'vimeo', 'twitch', 'dailymotion'];
  const matchingPlayers = players.filter(item => url.hostname.indexOf(item) > -1);

  if(matchingPlayers.length > 0){
    return matchingPlayers[0];
  }

  return undefined;

}


// Component
const Component = (props) => {

  const displaySettings = useMemo(() => multiOptionsToObject(props.block?.display_settings), [props.block?.display_settings]);
  const spacingBottomClass = useMemo(() => calculateBottomSpacingClass(props.block?.bottom_spacing), [props.block?.bottom_spacing]);
  
  const provider = useMemo(() => getProvider(props.block?.url) , [props.block?.url]);

  if(!props.block){
    return(<div>Storyblok block missing</div>);
  }

	return(
    <SbEditable content={props.block}>
      <StyledComponent {...props} className={`blockLargeVideo ${spacingBottomClass}`}>
        <WhiteBox 
          removeWhiteBox={displaySettings.removeWhiteBox} 
        >

          <div className="blockLargeVideo-wrapper">
              
            {provider !== undefined &&
              <ReactPlayer 
                width='100%'
                height='100%'
                url={props.block.url} 
                controls={true}
                className="blockLargeVideo-player"
              />
            }

          </div>

          {props.block.caption &&
            <div className="blockLargeVideo-caption">
              {props.block.caption}
            </div>
          }

        </WhiteBox>
      </StyledComponent>
    </SbEditable>
	)

}

export default Component


// Styles
const StyledComponent = styled.div`

    &:last-child{
      margin-bottom: 0;
    }


    .blockLargeVideo-wrapper{
      position: relative;
      padding-top: 56.25% /* Player ratio: 100 / (1280 / 720) */
    }
    
    .blockLargeVideo-player{
      position: absolute;
      top: 0;
      left: 0;
    }

    .blockLargeVideo-caption{
      padding: 1rem 10vw;
      font-family: ${theme.typography.fontFamilySecondary};
      font-weight: bold;
      text-align: center;
    }

`